import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./ProjectRealizationTaskSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";

import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { useMessageReceived } from "../../../../Utils/Socket/Socket";
import ProjectRealizationTaskModalFormStepOne from "./ProjectRealizationTaskModalFormStep/ProjectRealizationTaskModalFormStepOne";

const ProjectRealizationTaskModalForm = (props) => {
  const theme = useTheme();
  const {
    step,
    setStep,
    projectUuid,
    update,
    initialValues: _initialValues,
  } = props;
  const [initialValues, setInitialValues] = useState(null);
  const [workers, setWorkers] = useState([]);

  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  const fetchData = async () => {
    const workersFetch = GlobalAuthFetch({ path: "/worker/all" });
    const [workersPayload] = await Promise.all([workersFetch]);
    setWorkers(workersPayload?.payload?.data);
  };
  useEffect(() => {
    fetchData();
  }, []);

  // const fetchProjectData = async () => {};

  // useMessageReceived(fetchProjectData, {
  //   fakeHistory: `/project/${projectUuid}`,
  // });

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, { ...props, initialValues })}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <>
            <form
              id={props.formName}
              onSubmit={formProps.handleSubmit}
              className="ProjectRealizationTaskModalForm"
            >
              <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={step}
                onChangeIndex={(index) => setStep(index)}
              >
                <ProjectRealizationTaskModalFormStepOne
                  {...formProps}
                  {...props}
                  workers={workers}
                />
              </SwipeableViews>
            </form>
          </>
        );
      }}
    </Form>
  );
};

export default ProjectRealizationTaskModalForm;
